export * from './NavigationRail';
export * from './NavigationRailItem/NavigationRailItem';
export * from './NavigationRailLink/NavigationRailLink';
export * from './model';
export * from './InternalNavigationRailItem/InternalNavigationRailItem';
import { provideChameleonDesignSystem } from '../common/ChameleonDesignSystem';
import { chameleonNavigationRail } from './NavigationRail.definition';
import { chameleonNavigationRailItem } from './NavigationRailItem/NavigationRailItem.definition';
import { chameleonNavigationRailLink } from './NavigationRailLink/NavigationRailLink.definition';
import { chameleonInternalNavigationRailItem } from './InternalNavigationRailItem/InternalNavigationRailItem.definition';
provideChameleonDesignSystem().register(chameleonNavigationRail(), chameleonNavigationRailLink(), chameleonNavigationRailItem(), chameleonInternalNavigationRailItem());
